import React from 'react';
import { Create, SimpleForm, TextInput, required } from 'react-admin';

const DeliveryPartnerCreate = props => (
    <Create {...props} redirect="list">
        <SimpleForm variant="outlined">
            <TextInput source="name" validate={required()} />
        </SimpleForm>
    </Create>
);

export default DeliveryPartnerCreate;
